import React, { Component } from 'react';
import axios from 'axios';
import SectionsPanel from './sections/sectionsPanel';
import SectionsTabs from './sections/sectionsTabs';
import appConstant from '../../../constants/app';

class Groups extends Component {
  state = {
    sections: [],
  }

  fetch = () => {
    let url = `${appConstant.API_URL}/section/all`;
    axios.get(url)
      .then(res => {
        const sections = res.data.sections;
        this.setState({ sections });
      }).catch(err => {
        console.log(err);
      });
  }

  componentDidMount () {
    this.fetch();
  }

  render () {
    const {
      sections,
    } = this.state;

    return (
      <div style={{
        backgroundColor: '#fff',
        marginTop: '60px',
      }}>
        <SectionsTabs sections={sections} />
        <SectionsPanel sections={sections} />
      </div>
    );
  }
}

export default Groups;



// WEBPACK FOOTER //
// ./src/app/screens/landing/sections.js